<template>
<div>
    <DataTable
      :value="equipos"
      dataKey="Id_equipo"
      ref="dt"
      v-model:filters="filters"
      :globalFilterFields="['MAC','NUM_SERIE','IP','MARCA','MODELO','UNIDAD','TIPO']"
      :loading="loading"
      responsiveLayout="scroll"
      scrollHeight="67vh"
    >
      <template #header>
        <div class="table-header w-full grid">
          <div class="col-3 flex align-items-center">
              <span class="text-2xl">Equipos</span>
          </div>
          <div class="p-field col-4">
              <Dropdown class="w-full"
                v-model="selectedUnidadFiltro"
                :options="lstUnidades"
                optionLabel="UNIDAD_SUBRED"
                placeholder="Selecciona una unidad"
                :filter="true"
                @change="cargarUniverso"
              />
            </div>
            <div class="p-field col-2">
                <!-- <label for="tipo">Tipo</label> -->
                <Dropdown
                    id="Id_tipo_dispositivo"
                    appendTo="body"
                    v-model="tipoSeleccionado"
                    :options="lstTipos"
                    optionLabel="Descripcion"
                    placeholder="Selecciona un tipo o escribe uno nuevo"
                    @change="cargarUniverso"
                />
            </div>
            <div class="col-3 flex justify-content-end">
              <div class="grid">
                <div class="col-6">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
                  </span>
                </div>
                <div class="col-6">
                  <download-excel 
                      class="btn w-full"
                      :data="equiposExport"
                      :stringifyLongNum="true"
                      :name="'Universo.xls'"
                      >
                      <Button label="Exportar"
                      icon="pi pi-download"
                      class="p-button-warning w-full" />       
                  </download-excel>
                </div>
              </div>
            </div>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>
      <Column field="UNIDAD" header="UNIDAD" sortable></Column>
      <Column field="TIPO_DISPOSITIVO" header="TIPO DISPOSITIVO" sortable></Column>
      <Column field="MARCA" header="MARCA" sortable></Column>
      <Column field="MODELO" header="MODELO" sortable></Column>
      <Column field="IP" header="IP" sortable></Column>
      <Column field="MAC" header="MAC" sortable></Column>
      <Column field="NUM_SERIE" header="Número de serie" sortable></Column>
      <template #footer>
        Registros en total {{ equipos ? equipos.length : 0 }}
      </template>
    </DataTable>
</div>
</template>
<script>
import Srvr from "../service/Inventario";
import {FilterMatchMode} from 'primevue/api';
import {mapGetters} from 'vuex';
import Utilerias from "../utilidades/Utilerias";
import Tipos_dispositivos from "../service/Tipos_dispositivos";
export default {
  data() {
    return {
      lstUnidades: [],
      selectedUnidadFiltro: null,
      equipos: null,  
      equiposExport: [],
      lstEquiposO: null,    
      lstTipos: null,
      tipoSeleccionado: null,
      lstModalidades: null, //['N/A','CONFIGURABLE','PLANO','SERVICIOS'],
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      filter:null,
      loading: false,
      fieldsExport:{
        REF:"REF",
        UNIDAD:"UNIDAD",
        SUBRED:"SUBRED",
        UBICACION:"UBICACION",
        TIPO:"TIPO",
        MARCA:"MARCA",
        MODELO:"MODELO",
        "NUMERO DE SERIE":"NUM_SERIE",
        MAC:"MAC",
        IP:"IP",        
      },
      tiposDispositivosService : new Tipos_dispositivos()
    };
  },
  created() {
  },
  mounted() {
    var t = this;
    t.filtroInicial();
    t.cargaInicial();
  },
  methods: {
    filtroInicial(){
      if(typeof this.$route.params.filter != 'undefined'){
        this.selectedUnidadFiltro = {
          UNIDAD: "TODOS",
          SUBRED: "TODOS",
          UNIDAD_SUBRED: "TODOS",
        };
      }
    },
    expandAll(){
      this.expandedRows = this.lstEquipos.filter(e=>e.Id_equipo);
    },
    collapseAll(){
      this.expandedRows = null;
    },
    forzarUpdate(){
      this.$forceUpdate();
    },
    verImg(i){
      this.verModelo = true;
      this.img = i;
    },
    cargaInicial() {
      var t = this;
      var ctlSvr = new Srvr();
      ctlSvr.getUnidades(t).then((res) => {
        t.lstUnidades = res;
        t.lstUnidades.unshift({
          UNIDAD: "TODOS",
          SUBRED: "TODOS",
          UNIDAD_SUBRED: "TODOS",
        });


      }).then(() => {
        this.tiposDispositivosService.getDispositivos(t).then((res) => {
            t.lstTipos = res;
            t.lstTipos.unshift({
                Id_tipo_dispositivo : -1,
                Descripcion: "TODOS",
            });

            if(t.$route.params.tipo){
                let tipoPrecargado = t.lstTipos.find(x => x.TIPO == t.$route.params.tipo);
                if(tipoPrecargado){
                    t.tipoSeleccionado = {...tipoPrecargado};
                }
            }else{
                t.tipoSeleccionado = {
                  Id_tipo_dispositivo : -1,
                  Descripcion: "TODOS",
                };
            }

            t.cargarUniverso();
        });
      });

    },
    cargarUniverso(){
        var t = this;
        if(t.selectedUnidadFiltro){
          var ctlSvr = new Srvr();
          ctlSvr.getUniversoEquipos(t,t.selectedUnidadFiltro ? t.selectedUnidadFiltro.SUBRED : null,t.tipoSeleccionado?.Id_tipo_dispositivo?? null).then((res) => {
            t.loading = false;
            t.equipos = res;
            t.equiposExport = res.map(e => {
              delete e.Id_mantenimiento_equipo
              delete e.Id_mantenimiento
              delete e.Id_equipo
              delete e.REF
              delete e.POE
              delete e.ENLA_ENTRADA
              delete e.ENLA_SALIDA
              delete e.CONFIGURABLE
              delete e.Fecha_mantenimiento
  
              return e;
            });
          });
        }
    },
    formateaFechaAMD(fecha){
      var utils = new Utilerias();
      return utils.formateaFechaAMD(fecha);
    },
  },
  computed:{
        ...mapGetters(['getUsuarioLogueado']),  
  }, 
};
</script>